const Glide = window.Glide;
import { centerControlsOnImage, disableIfGlideFit, setButtonsVisibility } from "../../../Scripts/glideControls.js";
const featuredProducts = (()=> {
  function setUpCarousel () {
  const sliderProducts = document.querySelectorAll(".block__featuredProducts > .glide");
  const imageHolder = document.querySelector(".block__featuredProducts .block__imageHolder");
  const glideControls = document.querySelectorAll(".block__featuredProducts .block__glideControls");

  let glides = [];
  const options = {
      perView: 4,
      peek: { before: 0, after: 91 },
      bound: true,
      gap: 16,
      rewind: false,
      breakpoints: {
        500: {
          perView: 1,
          peek: { before: 0, after: 70 },
          gap: 16,
        },
        649: {
          perView: 2,
          peek: { before: 0, after: 70 },
          gap: 16,
        },
        767: {
          perView: 2  ,
          peek: { before: 0, after: 186 },
          gap: 16,
        },
        1023: {
          perView: 2,
          peek: { before: 0, after: 156 },
          gap: 16,
        },
        1365: {
          perView: 3,
          gap: 16,
          peek: { before: 0, after: 150 },
        },
      },
    };
    sliderProducts.forEach((slider) => {
    let glide = new Glide(slider, options);
    glide.on("move.after",  () => {
      let firstButton = glide.selector.querySelector(".button__glide.button__prev");
      let lastButton = glide.selector.querySelector(".button__glide.button__next");
      let numOfSlides = glide.selector.querySelectorAll(".glide__slide").length;
      setButtonsVisibility(glide, firstButton, lastButton, numOfSlides);
    });
    glide.on("build.after", ()=> {
      centerControlsOnImage(imageHolder,glideControls)
    });
    glides.push(glide.mount());

        $(slider).on('glideUpdate', function () { //update on content change
            glide.update();
        });
  });
  for(let i = 0; i < glides.length; i++) {
    disableIfGlideFit(glides[i]);
    }
    $("document").ready(function () {
        if ($(".featured-products-section").hasClass("feature-product-exhibitor")) {
            const disableSlidesBasedOnViews = () => {
                if (window.Foundation.MediaQuery.atLeast("medium")) {
                    if (glides.length === 0) {
                        return;
                    }
                    glides.forEach(glide => glide.destroy());
                    glides = [];
                } else {
                    if (glides.length !== 0) {
                        return;
                    }
                    sliderProducts.forEach((slider) => {
                        let glide = new Glide(slider, options);
                        glide.on("move.after", () => {
                            let firstButton = glide.selector.querySelector(".button__glide.button__prev");
                            let lastButton = glide.selector.querySelector(".button__glide.button__next");
                            let numOfSlides = glide.selector.querySelectorAll(".glide__slide").length;
                            setButtonsVisibility(glide, firstButton, lastButton, numOfSlides);
                        });
                        glides.push(glide.mount());
                    });
                }
            }
            disableSlidesBasedOnViews();

            window.addEventListener("resize", () => {
                //disable glides at certain screen sizes (medium and up in this case)
                disableSlidesBasedOnViews();
                // disable glides if there is not enough slides to overflow screen
                for (let i = 0; i < glides.length; i++) {
                    disableIfGlideFit(glides[i]);
                }
                centerControlsOnImage(imageHolder, glideControls);

                //reset view more button if activated and beneath a certain size
                if (!window.Foundation.MediaQuery.atLeast("medium")) {
                    const viewMoreButtons = document.querySelectorAll(".featured-products-section .button__viewMore");
                    viewMoreButtons.forEach(viewMoreButton => {
                        if (viewMoreButton.style.display === "none") {
                            viewMoreButton.style.display = "";
                            const glideSlidesElm = viewMoreButton.parentElement.parentElement.querySelector(".glide__slides");
                            if (glideSlidesElm) {
                                glideSlidesElm.style = "";
                            }
                        }
                    })
                }
            });
        }
    });

    if(sliderProducts) {
      window.addEventListener("resize", () => {

          for(let i = 0; i < glides.length; i++) {
          disableIfGlideFit(glides[i]);
        }
          centerControlsOnImage(imageHolder, glideControls);
      });
    }
  }
  setUpCarousel();
  return {setUpCarousel : setUpCarousel}
})();

export { featuredProducts };